<template>
    <div class="admin admin-public-part-lot">
      <p class="admin-title a-flex-start a-align-items-center">
        {{$t('form.tender.tender-title', {number: tender.id})}}
        <router-link :to="{name: 'purchases-tender-details', params: { tenderId: tender.id, tab: 'overview'}}"
                     class="gui-btn gui-btn--red gui-btn--w-300 u-margin-left-20"
                     v-if="tender.permissions.CAN_VIEW_VOTING_RESULTS">
          В форму формирования извещения
        </router-link>
      </p>

      <div class="a-tab" id="accordion-tab">
        <div class="a-tab__control">
          <!--<router-link to="overview" tag="button" type="button" class="a-tab__btn" active-class="a-active " >Основные данные</router-link>-->
          <!--<router-link to="specifications" tag="button" type="button" class="a-tab__btn" active-class="a-active">Спецификации</router-link>-->
          <!--<router-link v-if="accreditation" to="accreditation" tag="button" type="button" class="a-tab__btn" active-class="a-active">Аккредитация</router-link>-->
        </div>
        <div class="collapse show" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
          <form class="human-data" action="">
            <overview :tender="tender"></overview>
            <attached-lots :tender="tender"></attached-lots>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
  import Overview from './Overview'
  import AttachedLots from './AttachedLots'

  export default {
    props: {
      tender: Object
    },

    components: {
      Overview, AttachedLots
    }
  }
</script>

<style>
  .a-tab__btn {
    color: #4C4C4C;
    border-bottom: 1px solid transparent;
  }

  .a-tab__btn.a-active {
    color: #E30613;
    border-bottom: 1px solid #E30613;
  }
</style>
